import type { SiteConfig, StatItem } from '../../../siteContentTypes.ts';
import { TextField, TextAreaField, NumberField, ColorField, SelectField, ToggleField, ListEditor } from './fields.tsx';
import { ICON_NAMES } from '../../../lib/icons.ts';

export function StatisticsSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const s = config.statistics;
  const set = (patch: Partial<SiteConfig['statistics']>) => update({ statistics: { ...s, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Chiffres</h2>
      <TextField label="Titre de la section" value={s.title} onChange={(v) => set({ title: v })} />
      <ListEditor<StatItem>
        items={s.items}
        onChange={(items) => set({ items })}
        itemLabel="une statistique"
        newItem={() => ({ value: 0, prefix: '', suffix: '', title: 'Nouvelle statistique', description: '', icon: 'star', color: '#D9622B', order: s.items.length, visible: true })}
        renderItem={(item, patch) => (
          <>
            <NumberField label="Valeur" value={item.value} onChange={(v) => patch({ value: v })} />
            <TextField label="Préfixe" value={item.prefix} onChange={(v) => patch({ prefix: v })} />
            <TextField label="Suffixe" value={item.suffix} onChange={(v) => patch({ suffix: v })} />
            <TextField label="Titre" value={item.title} onChange={(v) => patch({ title: v })} />
            <TextAreaField label="Description" value={item.description} onChange={(v) => patch({ description: v })} rows={2} />
            <SelectField label="Icône" value={item.icon} onChange={(v) => patch({ icon: v })} options={ICON_NAMES.map((n) => ({ value: n, label: n }))} />
            <ColorField label="Couleur" value={item.color} onChange={(v) => patch({ color: v })} />
            <ToggleField label="Visible" value={item.visible} onChange={(v) => patch({ visible: v })} />
          </>
        )}
      />
    </div>
  );
}
